<template>
  <md-app md-waterfall md-mode="fixed" class="c-home">
    <md-app-toolbar md-elevation="4" class="u-fixed md-dense">
      <md-button class="md-icon-button" @click="menuVisible = !menuVisible">
        <md-icon>menu</md-icon>
      </md-button>
      <topbarmenu :show-links="['export', 'account']"></topbarmenu>
    </md-app-toolbar>
    <md-app-drawer :md-active.sync="menuVisible">
      <drawermenu></drawermenu>
    </md-app-drawer>
    <md-app-content class="o-fullscreen">
      <profileSummary></profileSummary>
      <overview></overview>
    </md-app-content>
  </md-app>
</template>

<script>
import { mapGetters } from "vuex";

import drawermenu from "./partials/MenuDrawer";
import topbarmenu from "./partials/MenuTopbar";
import overview from "./partials/OverVue";
import profileSummary from "./partials/ProfileSummary";
import { translate, googleTags } from "../mixins";

export default {
  name: "HelloWorld",
  mixins: [translate, googleTags],
  components: {
    drawermenu,
    topbarmenu,
    overview,
    profileSummary
  },
  mounted() {
    this.gTagScreenView("Home");
  },
  computed: {
    ...mapGetters(["isKnownUser"]),
    user() {
      return this.$store.state.user;
    }
  },
  data() {
    return {
      menuVisible: false,
      userActions: false
    };
  }
};
</script>

<style lang="scss" scoped>
.c-home {
  .md-avatar {
    .md-icon.md-icon-font {
      width: 40px;
      height: 40px;
      font-size: 40px !important;
    }
  }
}
.md-app-toolbar {
  --md-theme-default-text-primary-on-background: var(--color-text);
  --md-theme-default-text-primary-on-background-variant: var(--color-text);
  background-color: #ffffff;
  z-index: 5;
}

.md-app-toolbar.md-no-elevation {
  --md-theme-default-text-primary-on-background: var(--color-text-invert);
  --md-theme-default-text-primary-on-background-variant: var(--color-text-invert);
  background-color: transparent;
}
</style>
